import sha1 from '@republic/foundation/crypto/sha1';
import {map, reduce} from '@republic/foundation/lang/array';
import {stringify} from '@republic/foundation/lang/json';
import {owns} from '@republic/foundation/lang/object';
import {title} from '@republic/foundation/lang/string';
import {createPrefixed} from '@republic/foundation/storage';
import AuthStream from '../../auth/streams/AuthStream';
import session from '../../core/services/storage/session';
import {createRequestStream} from '../../core/streams';

const
    parseDate = (date = '') => {
        const [match, year, month, day] = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(date) || [];

        return (
            match ?
                (new Date(
                    parseInt(year, 10),
                    parseInt(month, 10) - 1,
                    parseInt(day, 10))
                .toISOString()) :
                null);
    };

export default (
    createRequestStream(
        'Subscribers',
        {
            code: 'accounts/subscribers',
            error: 'A request for subscribers information failed',
            singleton: true
        },
        createPrefixed(session, 'accounts/subscribers/3.0', 15 * 60),
        {auth: AuthStream},
        ({auth}) => (
            auth.id ?
                sha1(
                    stringify({
                        id: auth.id
                    })) :
                null),
        subscribers => !!subscribers.data,
        () => true,
        ({auth: {token}}) => (
            fetch(
                '/fractus/p/stratus/rest/v3/subscribers;view=portal',
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })),
        raw => ({
            data: (
                reduce(
                    raw || [],
                    (data, subscriber) => (
                        reduce(
                            subscriber.devices || [],
                            (subscribers, device) => {
                                const
                                    {
                                        billing_uuid: line,
                                        current_prepay_action: prepay
                                    } = device;

                                if (!owns(data.by, line)) {
                                    data.by[line] = {
                                        line,
                                        devices: [],
                                        bill_date: parseDate(subscriber.next_bill_date),
                                        contract_date: subscriber.contract_payment_next_due_date ? parseDate(subscriber.contract_payment_next_due_date) : null,
                                        status: subscriber.status
                                    };
                                    data.subscribers.push(data.by[line]);
                                }
                                data.by[line].devices.push({
                                    id: device.id,
                                    sim: device.iccid,
                                    sku: device.sku,
                                    status: device.status,
                                    warranty: new Date(device.device_guarantee_end_date) >= new Date(),
                                    relaygo_purchase: device.distribution_channel === 'RW Web Store',
                                    name: (
                                        device.ibot_label && device.ibot_label !== '' ?
                                            device.ibot_label :
                                            device.ibot_name ?
                                                (map(
                                                    (device.ibot_name || '').split(':'),
                                                    name => title(name))
                                                .join(' ')) :
                                                'Unnamed Relay'),
                                    prepay: {
                                        ...prepay ?
                                            {
                                                id: String(prepay.order_id),
                                                begin: parseDate(prepay.prepay_begin_date),
                                                end: parseDate(prepay.prepay_end_date)
                                            } :
                                            {},
                                        active: !!(
                                            prepay &&
                                            prepay.status !== 'Deleted' &&
                                            prepay.status !== 'Cancelled' &&
                                            prepay.status !== 'Error' &&
                                            prepay.prepay_status !== 'Inactive'),
                                        cancellable: (
                                            !!(prepay && prepay.order_id) && (
                                                prepay.status === 'New' ||
                                                prepay.status === 'Pending'))
                                    }
                                });
                                return data;
                            },
                            data)),
                    {
                        by: {},
                        subscribers: []
                    })
                .subscribers)
        }),
        () => ({data: undefined})));
